export default __webpack_public_path__ + "static/social1-02b780f300765ae1efef2da591470008.png";